/* eslint-disable */
import React from "react";

import { Thead, Th } from "./styles";

const TableHead = ({ columns }: any) => {
  return (
    <Thead>
      <tr>
        {columns.map(({ label, accessor }: any) => {
          return (
            <Th style={{ textAlign: "left" }} key={accessor}>
              {label}
            </Th>
          );
        })}
      </tr>
    </Thead>
  );
};

export default TableHead;
